import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { Seo } from '../components/ui/Seo';
import { PageHero } from '../components/ui/PageHero';
import { CourseFilterGrid, courseFilters } from '../components/courses/CourseFilterGrid';
import type { CourseFilter } from '../components/courses/CourseFilterGrid';
import { CtaBand } from '../components/shared/CtaBand';
import { IMAGES } from '../data/images';
import { BOOKING_URL } from '../data/site';
import { ButtonLink } from '../components/ui/ButtonLink';
export function Courses() {
  const [params, setParams] = useSearchParams();
  const raw = params.get('filter');
  const filter: CourseFilter = courseFilters.includes(raw as CourseFilter) ? raw as CourseFilter : 'All';
  const setFilter = (f: CourseFilter) => {
    if (f === 'All') setParams({}, {
      replace: true
    });else setParams({
      filter: f
    }, {
      replace: true
    });
  };
  return <>
      <Seo title="Firearms Courses in Las Vegas" description="Concealed carry class Las Vegas, Nevada CCW renewal, defensive handgun, carbine, home defense, women-only, NRA and USCCA courses." data-id="element-797" data-mp="2sp5w90r72uab" />
      <PageHero title="Every Course. One Clear Path." sub="CCW permits, defensive handgun, carbine, home defense, women-only, NRA and USCCA — taught 7 days a week in Las Vegas." image={IMAGES.students} crumbs={[{
      label: 'Courses'
    }]} data-id="element-798" data-mp="3c3sqrkklbjhk">
        <ButtonLink href={BOOKING_URL} size="lg" data-id="element-799" data-mp="2ofhtssi0m3yk">
          Book a Class
        </ButtonLink>
        <ButtonLink to="/packages" size="lg" variant="outline-light" data-id="element-800" data-mp="2t5py8vsu34f0">
          Training Packages
        </ButtonLink>
      </PageHero>
      <section className="gutter section bg-mist" aria-label="Course list" data-id="element-801" data-mp="2ffuucc8uj885">
        <CourseFilterGrid filter={filter} onFilterChange={setFilter} data-id="element-802" data-mp="2kd4p87f08c3d" />
      </section>
      <CtaBand title="Not sure where to start?" sub="Call us and an instructor will recommend the right first course for you." primaryLabel="Book a Class" data-id="element-803" data-mp="25gnixulo9nno" />
    </>;
}